import { pick } from '@eastcoal/common/utils/object'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { useRichEditorStore } from '@eastcoal/editor/Store/hooks/useStore'
import { FontColorPicker as LocalFontColorPicker } from '@eastcoal/editor/ui/FontColorPicker'
import { FontColorPickerProps } from '@eastcoal/editor/ui/FontColorPicker/interface'

const Component = (props: FontColorPickerProps) => {
  const { defaultFontColor } = useRichEditorStore(state =>
    pick(state, ['defaultFontColor'])
  )

  return <LocalFontColorPicker {...props} defaultValue={defaultFontColor} />
}

export const FontColorPicker = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
